<template>
<div class="page-content margin-bottom-60">
    <div class="center-text own-title margin-bottom-20">
        {{data[loadIndex].header}}
    </div>
    <div class="content margin-bottom-10">
        <a href="/career-disturb">
            <img :src="'images/mpower-new/career/back-arrow.png'" />
        </a>
    </div>
    <div class="content">
        <div class="career-question-title margin-bottom-10">
            {{data[loadIndex].title}}
        </div>
        <div class="talent-question-desc line-height-normal">
            {{data[loadIndex].description}} 
        </div>
    </div>

    <div v-for="content in data[loadIndex].content" class="" :key="content.index">
        <div class="content">
            <div class="content">
                <div class="talent-question-desc line-height-normal text-left">
                    {{content.description}}
                </div>
            </div>
            <div v-for="first in content.question" class="content" :key="first.index">
                <div v-if="first.type === 'rate'">
                    <div class="career-category text-left margin-bottom-20">{{first.section}}</div>                    
                    <label class="career-radio-wrapper-text-left"  >{{content.min}}</label>
                    <label class="career-radio-wrapper" :class="first.value=='1'?'career-label-highlight':''"><input v-model="first.value" value="1" class="career-radio" type="radio" /> 1</label>
                    <label class="career-radio-wrapper" :class="first.value=='2'?'career-label-highlight':''"><input v-model="first.value" value="2" class="career-radio" type="radio" /> 2</label>
                    <label class="career-radio-wrapper" :class="first.value=='3'?'career-label-highlight':''"><input v-model="first.value" value="3" class="career-radio" type="radio" /> 3</label>
                    <label class="career-radio-wrapper" :class="first.value=='4'?'career-label-highlight':''"><input v-model="first.value" value="4" class="career-radio" type="radio" /> 4</label>
                    <label class="career-radio-wrapper" :class="first.value=='5'?'career-label-highlight':''"><input v-model="first.value" value="5" class="career-radio" type="radio" /> 5</label>
                    <label class="career-radio-wrapper-text-right"  >{{content.max}}</label>
                    <div :class="first.index+ ' error-remark'"></div>
                </div>

                <div v-else-if="first.type === 'checkbox'">
                    <div class="career-question-section line-height-normal text-left">{{first.section}}</div>
                    <div v-for="answer in first.answer" class="" :key="answer.index">
                        <label class="text-left talent-checkbox margin-bottom-30">
                            <input type="checkbox" :id="answer.index" :value="answer.title" v-model="first.value" :disabled="first.value.length > 2 && first.value.indexOf(answer.title) === -1" >
                            {{answer.title}}
                        </label>
                    </div>
                    <div class="clear"></div>
                    <div :class="first.index+ ' error-remark'"></div>
                </div>

                <div v-else-if="first.type === 'radio'">
                    <div class="career-question-section line-height-normal text-left margin-bottom-10">{{first.section}}</div>
                    <div v-for="answer in first.answer" :key="answer.index">
                        <label class="text-left talent-radio margin-bottom-10">
                            <input type="radio" :id="answer.index" :value="answer.title" v-model="first.value">
                            {{answer.title}}
                        </label>
                    </div>
                    <div class="clear"></div>
                    <div :class="first.index+ ' error-remark'"></div>
                </div>

                <div v-else-if="first.type === 'selection'">
                    <div class="checkboxes-demo">
                        <div class="career-question-section line-height-normal text-left margin-bottom-10 margin-top-40">{{first.section}}</div>
                            <div v-for="answer in first.answer" :class="'fac option'+first.index+answer.index +' margin-top-20'" :key="answer.index">
                                <input :id="'option'+first.index+answer.index" type="radio" class="amount_value" v-model="first.value" :name="first.index" :value="answer.title">
                                <label :for="'option'+first.index+answer.index"> {{answer.title}}</label>
                            </div>
                        <div class="clear"></div>
                    </div>
                    <div :class="first.index+ ' error-remark'"></div>
                </div>

                <div v-else-if="first.type === 'text'" :class="first.offset==true ?'sub-content':''">
                    <div class="career-question-section line-height-normal text-left margin-top-20 margin-bottom-20">{{first.section}}</div>
                    <input v-model="first.value" class="custom-input text-left text-area" :placeholder="first.placeholder" />
                    <div :class="first.index+ ' error-remark text-left'"></div>
                </div> 
            </div>
        </div>

        <div v-if="content.is_divider === 'true'">
            <div class="career-divider margin-top-30 margin-bottom-30"></div>
        </div>
    </div>

    <div class="talent-button-wrapper">
        <a @click="proceed()" class="generali-button-red">
            {{data[loadIndex].button}}
        </a>
    </div>
</div>
</template>
<style scoped>

.content {
    margin: 0px 15px;
}

::placeholder{
    color: #A6A5A4;
}
.career-question-title {
    font-size: 21px;
    color: #c1210c;
}
.career-question-desc {
    font-size: 13px;
    color: #7C7B7B;
}

.career-question-section {
    font-size: 13px;
    color: #7C7B7B;
}


.error-remark{
    font-size: 9px;
    color: #c1210c !important;
}

.career-width {
  max-width: 700px;
  margin: auto;
}

.career-divider {
    background:#000000;
    height: 2px;
}

.career-category {
    font-size: 14px;
    color: #c1210c;
}

/* Rate */
.career-radio-wrapper {
    width: calc(20% - 26px);
    display: inline-block !important;
    /* color: #7C7B7B; */
    height: 32px;
    line-height: 13.77px;
    
    padding: 10px 0;
    border: 1px solid #7C7B7B;
    font-size: 11.48px;
}
.career-radio-wrapper-text-right {
  
  width: 55.5px;
  display: inline-block !important;
  color: #7C7B7B;
  padding-top: 10px;
  height: 32px;
  line-height: normal;
  padding-left: 10px;
  border: 1px solid #7C7B7B;
  font-size: 13.33px;
  /* padding: 0px; */
  border: none;
}
.career-radio-wrapper-text-left {
    width: 74.5px;
    display: inline-block !important;
    color: #7C7B7B;
    height: 32px;
    line-height: normal;
    padding-right: 10px;
    padding-top: 10px;
    border: 1px solid #7C7B7B;
   
    font-size: 13.33px;
    /* padding: 0px; */
    border: none;
}
.career-radio {
    -webkit-appearance: none !important;
}

/* text */

.career-question-desc {
    font-size: 13px;
    color: #7C7B7B;
}

.sub-content{
    margin: 0px 20px 30px 20px;
}

.custom-input{
    color: #7A7B7A;
    background-color: transparent;
}

.text-area {
    /* padding: 0 10px; */
    border-bottom: 1px solid #7A7B7A;
    width: 100%;
    font-size: 13px;
}

/* selection */
.checkboxes-demo .fac {
    display: inline-block;
}
.fac>input+label:before,
.fac>span::after {
    color: transparent;
}

.fac label {
    border: 1px solid #000000;
    padding: 10px 15px;
    border-radius: 10px;
    min-width: 85px;
    /* margin-right: 15px; */
    background-color: #ffffff;
    color: #7A7B7A !important;
    font-size: 11px;
}

.fac-checkbox>input:checked+label,
.fac>input:checked+label {
    background-color: #DADAD9;
    color: #000000;
}


@media (min-width:765px){
    .career-category,.career-question-title{
        font-size: 21px;
    }
    .career-question-section,.career-label,.career-option,.button-m,p,.text-area, .fac label{
        font-size: 13px;
    }

    .sub-content{
        margin: 0px 15px 30px 15px;
    }
}

</style>
<script>
export default {
    name: "career_disturb",
    data(){
        return {
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "header": " Career & Lifestyle Survey Form",
                "title": "Solution",
                "content":[
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q5",
                                "section": "5. Based on estimation, how much you would need to make to live your desired lifestyle?",
                                "type": "text",
                                "placeholder": "Your Answer",
                                "value": ""
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q6",
                                "section": "6. Can you live your desired lifestyle by continuing working for your current job only?",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "Yes",
                                },{
                                    "index": 2,
                                    "title": "No",
                                }]
                            },
                            {
                                "index": "q6a",
                                "section": "If yes, how long will it need to takes",
                                "type": "text",
                                "placeholder": "Your Answer",
                                "offset": true,
                                "value": ""
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q7",
                                "section": "7.	If there is an opportunity which requires you to work hard for 3-5 years by following a proven system and likely will allow you to live your desired lifestyle, are you willing to invest 1-2 hours to explore?",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "Yes",
                                },{
                                    "index": 2,
                                    "title": "Will Consider",
                                },{
                                    "index": 3,
                                    "title": "Next time",
                                }]
                            },
                        ],
                        "is_divider": "false"
                    },
                ],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "header": " 职业和生活方式调查表",
                "title": "解决方案",
                "content":[
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q5",
                                "section": "5. 根据您的估计，要过上想要的生活方式，您一年需要赚多少钱？",
                                "type": "text",
                                "placeholder": "你的答案",
                                "value": ""
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q6",
                                "section": "6. 如果你继续现在的工作，你能实现你想要的生活方式吗？",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "能",
                                },{
                                    "index": 2,
                                    "title": "不能",
                                }]
                            },
                            {
                                "index": "q6a",
                                "section": "如果能，需要多长时间？",
                                "type": "text",
                                "placeholder": "你的答案",
                                "offset": true,
                                "value": ""
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q7",
                                "section": "7. 如果有一个机会，需要你努力工作 3-5 年，经过验证的系统，可能 会让您过上您想要的生活方式，您愿意投资1-2 小时探索吗？",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "愿意",
                                },{
                                    "index": 2,
                                    "title": "会考虑",
                                },{
                                    "index": 3,
                                    "title": "下次吧",
                                }]
                            },
                        ],
                        "is_divider": "false"
                    },
                ],
                "answer": "是",
                "button": "继续进行"
            },{
                "language": "bm",
                "header": "Kaji Selidik Kerjaya & Gaya Hidup",
                "title": "Penyelesaian",
                "content":[
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q5",
                                "section": "5. Berdasarkan anggaran anda, untuk menikmati gaya hidup yang diidamkan, berapa pendapatan yang anda perlukan setiap tahun?",
                                "type": "text",
                                "placeholder": "Jawapan Anda",
                                "value": ""
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q6",
                                "section": "6. Jika anda meneruskan pekerjaan anda sekarang, dapatkah anda mencapai gaya hidup keinginan anda?",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "Ya",
                                },{
                                    "index": 2,
                                    "title": "Tidak",
                                }]
                            },
                            {
                                "index": "q6a",
                                "section": "Jika ya, berapa lama masa yang diperlukan?",
                                "type": "text",
                                "placeholder": "Jawapan Anda",
                                "offset": true,
                                "value": ""
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q7",
                                "section": "7.	Jika ada peluang yang memerlukan anda bekerja keras selama 3-5 tahun dengan mengikuti sistem yang terbukti dan berkemungkinan akan membolehkan anda	mencapai gaya hidup impian anda, adakah anda sanggup meluangkan masa 1-2 jam untuk meneroka?",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "Ya",
                                },{
                                    "index": 2,
                                    "title": "Akan dipertimbangkan",
                                },{
                                    "index": 3,
                                    "title": "Lain kali",
                                }]
                            },
                        ],
                        "is_divider": "false"
                    },
                ],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('career_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('career_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('career_test')
            }
        }
    },
    methods: {
        proceed(){

            var status = false;
            for(var a = 0; a < this.data[this.loadIndex].content.length; a++){
                for(var d = 0; d < this.data[this.loadIndex].content[a].question.length; d++){
                    var question = this.data[this.loadIndex].content[a].question[d];

                    var error_msg = [
                        "*Please fill in the answer",
                        '*请填写答案',
                        '*Sila masukkan jawapan'
                    ];
               
                    if(question.value==''){
                        if(question.index == 'q6a'){
                            if(this.conclusion['q6'] == 'Yes'){
                                document.querySelector("."+question.index).innerHTML = error_msg[this.loadIndex];
                                status = true;
                            }else{
                                document.querySelector("."+question.index).innerHTML = "";
                            }
                        }else{
                            document.querySelector("."+question.index).innerHTML = error_msg[this.loadIndex];
                            status = true;
                        }
                    }else{
                        document.querySelector("."+question.index).innerHTML = "";
                        this.conclusion[question.index] = question.value;
                    }
                }
            }
            localStorage.setItem('career_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            if(status == false){
                this.$router.push({path: 'career-result'})
            } 
        },
        scrollToTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>